import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

// The member-facing update messages are shown verbatim, so unlike its siblings
// this error keeps the code on `code` only and never appends it to `message`.
export class ContentFeatureUpdateError extends CodedError {
  static get errorName() {
    return errorCodes.contentFeatureUpdateError.code;
  }

  constructor(message: string = errorCodes.contentFeatureUpdateError.message) {
    super(message);
    this.code = errorCodes.contentFeatureUpdateError.code;
    this.message = message;
    this.name = errorCodes.contentFeatureUpdateError.name;
    this.status = errorCodes.contentFeatureUpdateError.status;
  }
}
